import {
    SidebarInset,
    SidebarProvider,
    SidebarTrigger,
} from "@/Components/ui/sidebar"
import {AppSidebar} from "@/Components/New/AppSidebar.jsx";
import {
    Breadcrumb, BreadcrumbItem,
    BreadcrumbList,
    BreadcrumbPage,
    BreadcrumbSeparator
} from "@/Components/ui/breadcrumb.jsx";
import {Separator} from "@/Components/ui/separator.jsx";
import {Outlet, useLocation, useNavigate} from "react-router-dom";
import {Button} from "@/Components/ui/button.jsx";
import {Bell, WandSparkles} from "lucide-react";
import {
    DropdownMenu,
    DropdownMenuTrigger,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator
} from "@/Components/ui/dropdown-menu";
import {useNotifications} from "@/Contexts/NotificationProvider.jsx";
import {useContext, useEffect} from "react";
import {AuthContext} from "@/Contexts/AuthProvider.jsx";
import Cookies from "js-cookie";
import {API_URL} from "@/index.jsx";
import axios from "axios";


export default function DashboardLayout({children}) {
    const navigate = useNavigate();
    const {notifications, markAsRead, loading} = useNotifications();
    const {user, token} = useContext(AuthContext);
    const location = useLocation();

    const currency = Cookies.get('currency') || 'CZK';

    useEffect(() => {
        if (!user) {
            navigate("/login", {replace: true});
            return;
        }
        if (user.special_offer || user.specialOffer) {
            const fbId =  Cookies.get('_fbc');
            const endpoint = `${API_URL}/user/create-checkout/special/yearly`
            axios.post(
                endpoint,
                {email: user.email, fbid: fbId, currency},
                {
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        "Content-Type": "application/json"
                    }
                }
            ).then(link => {
                console.log(link)
                window.location.href = link.data.checkoutUrl;
            })
        }
    }, []);


    if (!user) {
        navigate("/login");
        return;
    }

    const bannedRoutes = [
        "/",
        "/login",
        "/register",
        "/about",
        "/ai-chat",
        "/pricing-trial",
        "/blog",
        "/editor",
        "/contact",
        "/blog/",
        "/tos",
        "/gdpr",
        "/refund-policy",
        "/cookies",
        "/password-reset"
    ];

    return (!bannedRoutes.includes((location.pathname)) && (
            <SidebarProvider>
                <AppSidebar className={"border-sidebar-accent"}/>
                <SidebarInset>
                    <header
                        className="flex h-16 w-full shrink-0 items-center border-b border-b-sidebar-accent gap-2 bg-sidebar">
                        <div className="flex items-center justify-between w-full gap-2 px-6">
                            <SidebarTrigger className="-ml-1"/>
                            <div className={"flex items-center gap-4"}>
                                <DropdownMenu>
                                    <DropdownMenuTrigger asChild>
                                        <Button variant="secondary" size="icon">
                                            <Bell/>
                                        </Button>
                                    </DropdownMenuTrigger>
                                    <DropdownMenuContent align="end" className="w-80">
                                        <DropdownMenuLabel>Notifikace</DropdownMenuLabel>
                                        <DropdownMenuSeparator/>
                                        {notifications.length === 0 ? (
                                            <DropdownMenuItem className="text-gray-500 dark:text-gray-400">Žádné nové
                                                notifikace</DropdownMenuItem>
                                        ) : (
                                            notifications.map((note) => (
                                                <DropdownMenuItem key={note.notification_id}
                                                                  className="flex flex-col items-start space-y-1">
                                                    <div
                                                        className="w-full flex justify-between items-center text-xs text-muted-foreground">
                                                    <span>
                                                      {new Date(note.date).toLocaleDateString("cs-CZ", {
                                                          year: "numeric",
                                                          month: "long",
                                                          day: "numeric",
                                                      })}
                                                    </span>
                                                        {!note.read && (
                                                            <button
                                                                className="text-primary hover:underline text-xs"
                                                                onClick={(e) => {
                                                                    e.stopPropagation(); // nezavře dropdown
                                                                    markAsRead(note.notification_id);
                                                                }}
                                                            >
                                                                Označit jako přečtené
                                                            </button>
                                                        )}
                                                    </div>
                                                    <p className="text-sm">{note.text}</p>
                                                </DropdownMenuItem>
                                            ))
                                        )}
                                    </DropdownMenuContent>
                                </DropdownMenu>
                            </div>
                        </div>
                    </header>
                    <div className="flex flex-1 flex-col p-4 md:p-8">
                        <Outlet/>
                    </div>
                </SidebarInset>
            </SidebarProvider>)
    )
}
